import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Mdc, MdcCode, MdcOffline, MdcOfflineSync } from './mdc.model';
import { HttpClient } from '@angular/common/http';
import { Item, Item1, Item2 } from '../generic/item.model';
import { Msg, MsgQrCode } from '../generic/msg.model';
import { Lang } from '../generic/lang.model';
import { MetodoVerificacao, Verification } from '../verification/verification.model';
import { CryptographService } from '../security/cryptograph.service';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { catchError, forkJoin, map, Observable, of, tap } from 'rxjs';
import { LocalstorageService } from '../localstorage/localstorage.service';
import { PaisService } from '../pais/pais.service';
import { LocalizacaoService } from '../localizacao/localizacao.service';
import { TranslateService } from '@ngx-translate/core';

declare var Swal: any;

@Injectable({
  providedIn: 'root'
})
export class MdcService {

  [key: string]: any;

  isLoading = true;
  version = "V 1.0.6";
  err_connection_refused = false;
  isSavingOffline = false;
  isSavingFromLocalStorage = false;
  counterResendCode: number = 30;
  isDisabledResendCode: boolean = true;
  qrCodeImage: string = '';
  captchaImageUrl: string = '';
  private storageKeyForm = 'savedMdCForm';
  private storageKeyInitial = 'savedMdCInitial';
  private storageKeyList = 'savedMdCFormList';

  constructor(private http: HttpClient,
    private cryptographService: CryptographService,
    private router: Router,
    private translateService: TranslateService,
    private authService: AuthService,
    private localstorageService: LocalstorageService,
    private paisService: PaisService,
    private locService: LocalizacaoService) { }

  //#region url
  urlMdc: string = environment.apiBaseURL + '/Mdc/Code'
  urlMdcAuth: string = environment.apiBaseURL + '/Mdc/Auth'
  urlMdcSyncOff: string = environment.apiBaseURL + '/Mdc/SyncOff'
  urlQuestao: string = environment.apiBaseURL + '/Questao?lang='
  urlOpcao: string = environment.apiBaseURL + '/Opcao?lang='
  urlAtividade: string = environment.apiBaseURL + '/Atividade?lang='
  urlVerification: string = environment.apiBaseURL + '/Verification/envia-codigo'
  urlVerificationQrCode: string = environment.apiBaseURL + '/Verification/gerrar-qr-code'
  urlVerificationCaptcha: string = environment.apiBaseURL + '/Verification/gerrar-captcha'
  urlMetodoVerificacao: string = environment.apiBaseURL + '/Verification/metodos'
  //#endregion

  //#region var
  email: string = '';
  phoneNumber: number | null = null;
  selectedMethod: string = '';
  selectedPais: string = '';
  isSelectedPais: boolean = false;
  selectedI2Control: boolean = false;
  formData: Mdc = new Mdc();
  formVerification: Verification = new Verification();
  formCodeData: MdcCode = new MdcCode();
  metodoVerificacao: MetodoVerificacao[] = [];
  //#endregion

  //#region list
  questao: Lang[] = [];
  i1options: Item2[] = [];
  mdc2options: Item2[] = [];
  mdc5options: Item2[] = [];
  mdc6options: Item2[] = [];
  mdc7options: Item2[] = [];
  mdc8options: Item2[] = [];
  mdc10options: Item2[] = [];
  mdc11options: Item1[] = [];
  mdc13options: Item2[] = [];
  mdc15options: Item2[] = [];
  mdc17options: Item2[] = [];
  mdc18options: Item2[] = [];
  mdc20options: Item2[] = [];
  mdc21options: Item2[] = [];
  mdc22options: Item2[] = [];
  mdc24options: Item2[] = [];
  mdc25options: Item2[] = [];
  mdc29options: Item2[] = [];
  mdc30options: Item1[] = [];
  mdc32options: Item2[] = [];
  mdc33options: Item1[] = [];
  mdc34options: Item1[] = [];
  mdc36options: Item2[] = [];
  mdc38options: Item1[] = [];
  mdc39options: Item2[] = [];
  mdc40options: Item2[] = [];
  mdcSimNaoOptions: Item2[] = [];
  mdcSimNaoNaoSabeOptions: Item2[] = [];

  ano_max: number = 125;
  ano_atual: number = new Date().getFullYear()
  mdc9_ano_minimo: number = 1900;
  mdc10_ano_minimo: number = 0;

  //this.formData.mdc_4 ? this.formData.mdc_4.getFullYear() : 1462

  //#endregion 

  getLabelByLang(lang: string): Observable<Lang[]> {
    return this.http.get<Lang[]>(this.urlQuestao + lang).pipe(
      tap(res => {
        this.questao = res as Lang[];
      }),
      catchError(err => {
        console.error('Erro ao carregar label:', err);
        return of([]);
      })
    );
  }

  getAtividadesByLang(lang: string): Observable<Item2[]> {
    return this.http.get<Item2[]>(this.urlAtividade + lang).pipe(
      tap(result => {
        const data = result as Item2[];

        var other_activities = this.translateService.instant('other_activities')

        this.mdc24options = [
          { id: 0, name: other_activities, value: 0 },
          ...data
        ];

      }),
      catchError(err => {
        console.error('Erro ao carregar atividades:', err);
        return of([]);
      })
    );
  }

  getMdcOptions(lang: string): Observable<Item[]> {
    return this.http.get<Item[]>(this.urlOpcao + lang).pipe(
      tap(result => {
        this.mapOptions(result);
      }),
      catchError(err => {
        console.error('Erro ao carregar options:', err);
        return of([]);
      })
    );
  }

  private mapOptions(result: Item[]): void {
    this.mapGeneralOptions(result);
    this.mapSpecificOptions(result);
  }

  private mapGeneralOptions(result: Item[]): void {

    const generalMappings = [
      { key: "i_1", target: "i1options" },
      { key: "mdc_2", target: "mdc2options" },
      { key: "mdc_5", target: "mdc5options" },
      { key: "mdc_6", target: "mdc6options" },
      { key: "mdc_7", target: "mdc7options" },
      { key: "mdc_8", target: "mdc8options" },
      { key: "mdc_10", target: "mdc10options" },
      { key: "mdc_13", target: "mdc13options" },
      { key: "mdc_15", target: "mdc15options" },
      { key: "mdc_17", target: "mdc17options" },
      { key: "mdc_18", target: "mdc18options" },
      { key: "mdc_20", target: "mdc20options" },
      { key: "mdc_21", target: "mdc21options" },
      { key: "mdc_22", target: "mdc22options" },
      { key: "mdc_25", target: "mdc25options" },
      { key: "mdc_29", target: "mdc29options" },
      { key: "mdc_32", target: "mdc32options" },
      { key: "mdc_36", target: "mdc36options" },
      { key: "mdc_39", target: "mdc39options" },
      { key: "mdc_40", target: "mdc40options" },
      { key: "mdc_sim_nao", target: "mdcSimNaoOptions" },
      { key: "mdc_sim_nao_nao_sabe", target: "mdcSimNaoNaoSabeOptions" },
    ];

    generalMappings.forEach(mapping => {
      this[mapping.target] = this.mapToItem2List(result, mapping.key);
    });
  }

  private mapSpecificOptions(result: Item[]): void {

    const specificMappings = [
      { key: "mdc_11", target: "mdc11options" },
      { key: "mdc_30", target: "mdc30options" },
      { key: "mdc_33", target: "mdc33options" },
      { key: "mdc_34", target: "mdc34options" },
      { key: "mdc_38", target: "mdc38options" },
    ];

    specificMappings.forEach(mapping => {
      this[mapping.target] = this.mapToItem1List(result, mapping.key);
    });
  }

  getMetodoVerificacao(): Observable<MetodoVerificacao[]> {
    return this.http.get<MetodoVerificacao[]>(this.urlMetodoVerificacao).pipe(
      tap(result => {
        this.metodoVerificacao = result as MetodoVerificacao[];
      }),
      catchError(err => {
        console.error('Erro ao carregar metodos de verificacão:', err);
        return of([]);
      })
    );
  }

  mapToItem1List(result: Item[], code: string): Item1[] {
    var items = result.filter(obj => obj.code === code).sort((a, b) => a.id - b.id);
    return items.map(item => {
      return {
        id: item.value,
        name: item.name,
        isSelected: false
      };
    });
  }

  mapToItem2List(result: Item[], code: string): Item2[] {
    var items = result.filter(obj => obj.code === code).sort((a, b) => a.id - b.id);
    return items.map(item => {
      return {
        id: item.id,
        name: item.name,
        value: item.value,
      };
    });
  }

  postMdc() {
    this.locService.getLocalizacaoCustum().subscribe({
      next: dados => {
        this.formData.localizacao = this.locService.mapearParaLocalizacao(dados);
        this.confirmPost();
      },
      error: err => {
        console.error('Erro ao obter localização');
        this.confirmPost();
      }
    });
  }

  confirmPost() {
    this.formCodeData.code = this.formCodeData.code.toString();
    this.formCodeData.mdc = this.formData;
    this.formCodeData.lang = localStorage.getItem('lang') || 'pt';
    const payload = this.cryptographService.encryptData(this.formCodeData);
    this.http.post(this.urlMdc, payload).subscribe({
      next: res => {
        var msg = res as Msg;
        Swal.fire({ title: msg.title, text: msg.text, icon: msg.icon }).then(() => {
          this.removeLocalStorageFormData();
          window.location.reload();
        });
      },
      error: err => {
        Swal.fire({ title: err.error.title, text: err.error.text, icon: err.error.icon });
      }
    });
  }

  postMdcAuto() {
    this.locService.getLocalizacaoCustum().subscribe({
      next: dados => {
        this.formData.localizacao = this.locService.mapearParaLocalizacao(dados);
        this.confirmPostAuto();
      },
      error: err => {
        console.error('Erro ao obter localização');
        this.confirmPostAuto();
      }
    });
  }

  confirmPostAuto() {
    this.formCodeData.mdc = this.formData;
    this.formCodeData.lang = localStorage.getItem('lang') || 'pt';
    const payload = this.cryptographService.encryptData(this.formCodeData);
    this.http.post(this.urlMdcAuth, payload).subscribe({
      next: res => {
        var msg = res as Msg;
        Swal.fire({ title: msg.title, text: msg.text, icon: msg.icon }).then(() => {
          this.removeLocalStorageFormData();
          window.location.reload();
        });
      },
      error: err => {
        if (err.error != null) {
          Swal.fire({ title: err.error.title, text: err.error.text, icon: err.error.icon });
        }
        else {
          if (err.status === 401) {
            this.authService.showSessionExpiredAlert();
          } else {
            Swal.fire({ title: "Aviso", text: "Internal Server Error!", icon: "error" });
          }
        }
      }
    });
  }

  postVerirication(value: string) {
    this.formVerification.phonenumberoremail = value;
    this.formVerification.lang = localStorage.getItem('lang') || 'pt';
    this.http.post(this.urlVerification, this.formVerification).subscribe({
      next: res => {
        //console.log(res);
      },
      error: err => { console.error(err) }
    });
  }

  getGenerateQRCode(): void {
    this.http.get(this.urlVerificationQrCode).subscribe({
      next: res => {
        var msg = res as MsgQrCode;
        this.qrCodeImage = `data:image/png;base64,${msg.qrcode}`;
        this.formCodeData.phonenumberoremail = msg.guidcode
      },
      error: err => {
        Swal.fire({ title: err.error.title, text: err.error.text, icon: err.error.icon });
      }
    });
  }

  getGenerateCaptcha() {
    this.http.get(this.urlVerificationCaptcha).subscribe({
      next: res => {
        var msg = res as MsgQrCode;
        this.captchaImageUrl = `data:image/png;base64,${msg.qrcode}`;
        this.formCodeData.phonenumberoremail = msg.guidcode
      },
      error: err => {
        console.log(err)
        Swal.fire({ title: err.error.title, text: err.error.text, icon: err.error.icon });
      }
    });
  }

  getLabelByCode(codeToFind: string): string {
    const question = this.questao.find(item => item.code === codeToFind);
    return question ? question.label : '';
  }

  onChangePais(value: any) {
    if (value) {
      this.selectedPais = value.name;
      this.isSelectedPais = true;
    }
    else {
      this.selectedPais = '';
      this.isSelectedPais = false;
    }
  }

  onI2Change() {
    if (this.formData.i_2) {
      if (this.formData.i_2 == 2) {
        this.selectedI2Control = false;
        this.isSelectedPais = true;
      } else {
        this.selectedI2Control = true;
        this.isSelectedPais = this.formData.i_3! >= 1 ? true : false;
      }
    }
  }

  onMDC8Change() {
    this.mdc11options.forEach(option => { option.isSelected = false });
  }

  onMD3Change(): void {
    const dataNascimento = this.formData.mdc_4;
    if (dataNascimento) {
      const ano = new Date(dataNascimento).getFullYear();
      this.mdc9_ano_minimo = ano;
    } else {
      this.mdc9_ano_minimo = 1462;
    }
  }

  onMD4Change(dataNascimento: string): void {
    if (dataNascimento) {
      const hoje = new Date();
      const nascimento = new Date(dataNascimento);

      let idade = hoje.getFullYear() - nascimento.getFullYear();
      const m = hoje.getMonth() - nascimento.getMonth();

      if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--;
      }

      this.mdc9_ano_minimo = nascimento.getFullYear();
      this.formData.mdc_3 = idade >= 0 && idade <= 120 ? idade : null;
    } else {
      this.formData.mdc_3 = null;
      this.mdc9_ano_minimo = 1462;
    }
  }

  idadeConfereComData(): boolean {
    const dataNascimento = this.formData.mdc_4;
    const idadeInformada = this.formData.mdc_3;

    if (!dataNascimento || idadeInformada == null) return false;

    const nascimento = new Date(dataNascimento);
    const hoje = new Date();

    let idadeCalculada = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();

    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idadeCalculada--;
    }

    return idadeInformada === idadeCalculada;
  }

  onMultipliClickWithUniqueIdOption(option: any, variables: string, options: Item1[], uniqueId: number) {
    if (option.isSelected) {
      if (option.id === uniqueId) {
        var control: Boolean = false;
        options.forEach(opcao => {
          if (opcao.id !== uniqueId) {
            if (opcao.isSelected) {
              control = true;
            }
            opcao.isSelected = false;
          }
        });
        if (control) {
          this.formData[variables] = [];
          this.formData[variables].push(option.id);
        }
      } else {
        const singleOption = options.find(opcao => opcao.id === uniqueId);
        if (singleOption && singleOption.isSelected) {
          singleOption.isSelected = false;
          this.formData[variables] = [];
          this.formData[variables].push(option.id);
        }
      }
    } else {
      const otherOptionsSelected = options.some(opcao => opcao.isSelected && opcao.id !== uniqueId);
      if (!otherOptionsSelected) {
        const singleOption = options.find(opcao => opcao.id === uniqueId);
        if (singleOption) {
          singleOption.isSelected = false;
        }
      }
    }
  }

  onCheckboxChange(opcao: any, variables1: string, variables2: string, outro: number) {
    if (opcao.isSelected) {
      this.formData[variables1].push(opcao.id);
    } else {
      const index = this.formData[variables1].indexOf(opcao.id);
      if (index !== -1) {
        this.formData[variables1].splice(index, 1);
      }
    }
    const opcaoSeteSelecionada = this.formData[variables1].includes(outro);
    if (!opcaoSeteSelecionada) {
      this.formData[variables2] = null;
    }
  }

  isVisibleCheckBox(variables: string[], state: boolean, cls: any, options: Item1[]) {
    var result = this.isVisible(variables, state, cls);
    if (!result) {
      options.forEach(opcao => {
        opcao.isSelected = false;
      });
    }
    return result;
  }

  isVisible(variables: string[], state: boolean, cls: any) {
    if (!state) {
      variables.forEach(variable => {
        if (variable in this.formData) {
          this.clearFieldValue(variable, cls);
        }
      });
    }
    return state
  }

  clearFieldValue(fieldName: string, cls: any) {
    if (this.formData.hasOwnProperty(fieldName)) {
      if (this.formData[fieldName] !== null) {
        if (Array.isArray(this.formData[fieldName])) {
          if (this.formData[fieldName].length !== 0) {
            this.formData[fieldName] = [];
          }
        } else {
          this.formData[fieldName] = cls;
        }
      }
    }
  }

  nextValid(): boolean {
    if ((this.formData.i_2 != 2 && this.isSelectedPais == false) || (this.formData.mdc_6! > 1 && this.formData.mdc_6_1! < 1))
      // || (this.formData.mdc_22! == 1 && this.formData.mdc_24! < 1)
      return true
    else
      return false
  }

  prevValid(): boolean {
    if ((this.formData.mdc_6! > 1 && this.formData.mdc_6_1! < 1))
      // || (this.formData.mdc_22! == 1 && this.formData.mdc_24! < 1)
      return true
    else
      return false
  }

  cleanVerification(): void {
    this.selectedMethod = '';
    this.phoneNumber = null;
    this.email = '';
  }

  verification(): void {
    if (this.selectedMethod !== '') {
      if (this.selectedMethod == 'sms' && this.phoneNumber !== null) {
        this.postVerirication(this.phoneNumber.toString());
        this.formCodeData.phonenumberoremail = this.phoneNumber.toString();
        this.startCounter();
      }
      else if (this.selectedMethod == 'email' && this.email !== '') {
        this.postVerirication(this.email);
        this.formCodeData.phonenumberoremail = this.email;
        this.startCounter();
      }
      else if (this.selectedMethod == 'qrcode') {
        this.getGenerateQRCode();
      }
      else if (this.selectedMethod == 'captcha') {
        this.getGenerateCaptcha();
      }
    }
    this.saveLocalStorageFormData();
  }

  startCounter(): void {
    const interval = setInterval(() => {
      this.counterResendCode--;
      if (this.counterResendCode === 0) {
        this.isDisabledResendCode = false;
        clearInterval(interval);
      }
    }, 1000);
  }

  resendCode(): void {
    if (!this.isDisabledResendCode) {
      this.verification();
      this.isDisabledResendCode = true;
      this.counterResendCode = 30; // Reset counter
      this.startCounter(); // Restart countdown
    }
  }

  recaptcha(): void {
    this.getGenerateCaptcha();
  }

  saveLocalStorageFormData(): void {
    localStorage.setItem(this.storageKeyForm, JSON.stringify(this.formData));
  }

  saveLocalStorageInitialData(initial: any): void {
    localStorage.setItem(this.storageKeyInitial, JSON.stringify(initial));
  }

  loadLocalStorageFormData(): void {
    const savedData = localStorage.getItem(this.storageKeyForm);
    if (savedData) {
      this.formData = JSON.parse(savedData);
      this.syncCheckboxSelection('mdc_11', this.mdc11options);
      this.syncCheckboxSelection('mdc_30', this.mdc30options);
      this.syncCheckboxSelection('mdc_33', this.mdc33options);
      this.syncCheckboxSelection('mdc_34', this.mdc34options);
      this.syncCheckboxSelection('mdc_38', this.mdc38options);
    }
  }

  loadLocalStorageInitialData(): void {
    const savedInitialData = localStorage.getItem(this.storageKeyInitial);
    if (savedInitialData) {
      var initialData = JSON.parse(savedInitialData);
      this.questao = initialData.labels;
      this.paisService.listPaisEstrangeiros = initialData.paises;
      this.mapOptions(initialData.options);
      this.mdc24options = initialData.atividades;
      this.metodoVerificacao = initialData.metodo;
    }
  }

  syncCheckboxSelection(variable: string, options: any[]): void {
    const selectedValues = this.formData[variable] || [];
    options.forEach(option => {
      option.isSelected = selectedValues.includes(option.id);
    });
  }

  removeLocalStorageFormData(): void {
    localStorage.removeItem(this.storageKeyForm);
  }

  addToLocalStorageList(): void {
    if (this.isSavingOffline) return;
    this.isSavingOffline = true;
    Swal.fire({
      title: "Tem certeza que pretende salvar o formulario offline?",
      text: "Submeta o formulário assim que garantir uma conexão estável com a internet.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
      // @ts-ignore
    }).then((result) => {
      if (result.isConfirmed) {
        let formData: MdcOffline = { id: Date.now(), mdc: this.formData, data: new Date() };
        this.localstorageService.addToList(this.storageKeyList, formData);
        localStorage.removeItem(this.storageKeyForm);
        window.location.reload();
      }
      this.isSavingOffline = false;
    });
  }

  getFromLocalStorageList(): Observable<MdcOffline[]> {
    const list = this.localstorageService.getList<MdcOffline>(this.storageKeyList);
    return of(list);
  }

  submitFromLocalStorageList() {
    // 1. Verificação de guarda (perfeita, sem alterações)
    if (this.isSavingFromLocalStorage) return;
    this.isSavingFromLocalStorage = true;

    this.getFromLocalStorageList().subscribe({
      next: (list: MdcOffline[]) => {
        const total = list.length;

        if (total === 0) {
          Swal.fire({ title: "Aviso", text: "Nenhum formulário para enviar.", icon: "info" });
          this.isSavingFromLocalStorage = false;
          return;
        }

        let success = 0;
        let error = 0;

        const requests = list.map(mdcOffline => {
          this.formCodeData.mdc = mdcOffline.mdc;
          this.formCodeData.lang = localStorage.getItem('lang') || 'pt';
          const payload = this.cryptographService.encryptData(this.formCodeData);

          return this.http.post(this.urlMdcAuth, payload).pipe(
            map(response => {
              this.removeFromLocalStorage(mdcOffline.id);
              return { status: 'success', id: mdcOffline.id };
            }),
            catchError(err => {
              console.error(`Erro ao enviar o formulário ${mdcOffline.id}:`, err);
              return of({ status: 'error', id: mdcOffline.id });
            })
          );
        });

        forkJoin(requests).subscribe(results => {
          success = results.filter(r => r.status === 'success').length;
          error = results.filter(r => r.status === 'error').length;

          let title = "Sincronização Concluída";
          let text = `Enviados com sucesso: ${success}/${total}.`;
          let icon = "info";

          if (error > 0) {
            title = "Sincronização Parcial";
            text += ` Falharam: ${error}/${total}. Tente novamente para os restantes.`;
            icon = "warning";
          }

          Swal.fire({ title, text, icon }).then(() => {
            window.location.reload();
          });
        });
      },
      error: (err) => {
        console.error("Erro crítico ao ler do LocalStorage:", err);
        Swal.fire({ title: "Erro Crítico", text: "Não foi possível ler os dados locais.", icon: "error" });
        this.isSavingFromLocalStorage = false;
      }
    });
  }

  submitOffline(mdcOffline: MdcOffline): Observable<boolean> {
    this.formCodeData.mdc = mdcOffline.mdc;
    this.formCodeData.lang = localStorage.getItem('lang') || 'pt';
    const payload = this.cryptographService.encryptData(this.formCodeData);
    return this.http.post(this.urlMdcAuth, payload).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  removeFromLocalStorage(id: number): void {
    const list = this.localstorageService.getList<Mdc>(this.storageKeyList);
    const updatedList = list.filter(item => item.id !== id);
    this.localstorageService.saveList(this.storageKeyList, updatedList);
  }

  loadIntitalData(): void {
    const lang = localStorage.getItem('lang') || 'pt';
    forkJoin({
      labels: this.getLabelByLang(lang),
      paises: this.paisService.getPaisesEstrangeiros(lang),
      options: this.getMdcOptions(lang),
      atividades: this.getAtividadesByLang(lang),
      metodo: this.getMetodoVerificacao()
    }).subscribe({
      next: (result) => {
        this.saveLocalStorageInitialData(result);
        this.router.navigate(['/']);
      },
      error: (err) => {
        Swal.fire({
          title: 'Tenta novamente!',
          text: 'Erro ao carregar os dados iniciais.',
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Carregar'
        }).then(() => {
          this.loadIntitalData();
        });
      }
    });
  }

  loadForm(): void {
    const lang = localStorage.getItem('lang') || 'pt';
    forkJoin({
      labels: this.getLabelByLang(lang),
      paises: this.paisService.getPaisesEstrangeiros(lang),
      options: this.getMdcOptions(lang),
      atividades: this.getAtividadesByLang(lang),
      metodo: this.getMetodoVerificacao()
    }).subscribe({
      next: (res) => {
        if (res.labels.length > 0, res.paises.length > 0, res.options.length > 0, res.atividades.length > 0) {
          this.loadLocalStorageFormData();
          this.onI2Change();
        } else {
          if (this.authService.isAuthenticated()) {
            this.loadLocalStorageInitialData();
            this.loadLocalStorageFormData();
            this.onI2Change();
          } else {
            this.err_connection_refused = true;
          }
        }
        this.validateDate();
        this.isLoading = false;



        // this.locService.getLocalizacao().subscribe({
        //   next: localizacao => { this.formData.localizacao = localizacao; },
        //   error: err => { console.log('Error while starting connection to IP') }
        // });
      },
      error: (err) => {
        console.log('Erro ao carregar dados iniciais:', err);
      }
    });
  }

  validateDate() {
    var date = this.formData.mdc_4 ? new Date(this.formData.mdc_4.toString()) : null;
    if (date != null) {
      this.mdc9_ano_minimo = date?.getFullYear();
    }
  }

  reloadForm(): void {
    this.isLoading = true;
    this.err_connection_refused = false;
    this.loadForm();
  }

  //#region 
  enviarQuestionarios(questionarios: MdcOfflineSync[]) {
    const payload = questionarios.map(q => ({
      ...q,
      mdc: JSON.stringify(q.mdc)
    }));
    return this.http.post(this.urlMdcSyncOff, payload);
  }
  //#endregion
}